
import {
  computed, defineComponent, reactive,
} from 'vue';
import { IEngenhariaCip, IEngenhariaControle, IEngenhariaEtapa } from '@/models/Entidades/Cadastros/PCP/IEngenhariaProduto';
import LancarMateriaPrimaEtapaProducao from './LancarMateriaPrimaEtapaProducao.vue';
import LancarProdutoAcabadoEtapaProducao from './LancarProdutoAcabadoEtapaProducao.vue';
import EngenhariaControle from './EngenhariaControle.vue';
import EngenhariaCip from './EngenhariaCip.vue';

export default defineComponent({
  name: 'EngenhariaEtapasProducao',
  props: {
    etapas: {
      type: Array as () => IEngenhariaEtapa[],
      required: true,
    },
    tipo: {
      type: Number,
      required: true,
    },
    empresas: {
      type: Array as () => number[],
      required: true,
    },
    codigoEngenharia: {
      type: Number,
      required: true,
    },
    controles: {
      type: Array as () => IEngenhariaControle[],
      required: true,
    },
    cips: {
      type: Array as () => IEngenhariaCip[],
      required: true,
    },
    codigoTipoProducao: {
      type: Number,
      default: 0,
    },
    editavel: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LancarMateriaPrimaEtapaProducao,
    LancarProdutoAcabadoEtapaProducao,
    EngenhariaControle,
    EngenhariaCip,
  },
  emits: ['update:etapas', 'update:engenharia', 'update:cips'],
  setup(props, { emit }) {
    const state = reactive({
      indexSelecionado: 0,
      etapaSelecionada: 0,
      exibirProdutoAcabado: false,
      exibirMateriaPrima: false,
    });
    const computedEtapas = computed({
      get: () => props.etapas,
      set: (etapas: IEngenhariaEtapa[]) => {
        emit('update:etapas', etapas);
      },
    });

    const computedControle = computed({
      get: () => props.controles,
      set: (val: IEngenhariaControle[]) => {
        emit('update:engenharia', val);
      },
    });

    const computedCips = computed({
      get: () => props.cips,
      set: (val: IEngenhariaCip[]) => {
        emit('update:cips', val);
      },
    });
    return {
      props,
      state,
      computedEtapas,
      computedControle,
      computedCips,
    };
  },
});
